import { useSelector, useDispatch } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { loadUser } from "./redux/User"; // Import the action to load user data
import Cookies from "js-cookie";
import { FaSpinner } from "react-icons/fa";

const ProtectedRoute = ({ children }) => {

  const [showSignInPopup, setShowSignInPopup] = useState(false);
  const navigate=useNavigate()

  const dispatch = useDispatch();
  const { loading, isAuthenticated } = useSelector((state) => state.user);

  // Check if user is authenticated or not and load user if needed
  useEffect(() => {
    if (!isAuthenticated && localStorage.getItem("userId")) {
      // Dispatch action to load user data
      dispatch(loadUser(localStorage.getItem("userId")));
    } else if (!isAuthenticated && Cookies.get("accessToken")) {
      // Handle case where the token is available but not authenticated
      dispatch(loadUser(localStorage.getItem("userId")));
    }
  }, [dispatch, isAuthenticated]);

  console.log("🚀 ~ ProtectedRoute ~ loading:", loading);
  console.log("🚀 ~ ProtectedRoute ~ isAuthenticated:", isAuthenticated);

  // Show a loader while checking authentication
  if (loading) {
    return  <div className="flex justify-center items-center min-h-screen">
    <FaSpinner className="animate-spin text-4xl text-[#C97C2A]" />
  </div>
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;

  }

  // If authenticated, render the child component
  return children;
};

export default ProtectedRoute;
